// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1QE5q","header":"Messages_header__3JvOT"};